import { render, staticRenderFns } from "./TabPrePrompts.vue?vue&type=template&id=28e64b96&scoped=true"
import script from "./TabPrePrompts.vue?vue&type=script&lang=js"
export * from "./TabPrePrompts.vue?vue&type=script&lang=js"
import style0 from "./TabPrePrompts.vue?vue&type=style&index=0&id=28e64b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e64b96",
  null
  
)

export default component.exports